/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable import/extensions */
/* eslint-disable global-require */

import * as wvv from 'webvolumeview';
import toolNames from '../Header/Toolbar/toolNames.js';

let webvolumeview;


switch (__LIB3D__) {
  case 'local':
    webvolumeview = require('../../../../web-volume-viewer/lib-export.js');
    console.log('%c3D Local Development', 'padding: 2px 4px; font-weight: bold; font-size: 14px; color: #9b23d3; background: linear-gradient(90deg, #8886 0%, #1114 100%); text-shadow: .6px .6px 0 white');
    break;
  default:
    webvolumeview = wvv;
    console.log('%c3D Deployment Bundle', 'padding: 2px 4px; font-weight: bold; font-size: 14px; color: #2372d3; background-color: #3336; text-shadow: .6px .6px 0 white');
    break;
}

// -- Log lib3d version -- //
if (webvolumeview.version !== undefined) console.log(' 3D Version:', webvolumeview.version);

// -- App scope var -- //
let viewManager3d;
let is3DSupported;

const isWebGL2 = () => {
  if (is3DSupported !== undefined) return is3DSupported;

  let canvas;
  let gl;
  try {
    canvas = document.createElement('canvas');
    gl = canvas.getContext('webgl2');
  } catch (error) {
    console.warn('Unable to check WebGL2 support', error);
  }

  if (!gl) {
    if (typeof WebGL2RenderingContext !== 'undefined') {
      console.log('your browser appears to support WebGL2 but it might be disabled. Try updating your OS and/or video card drivers');
    } else {
      console.log('your browser has no WebGL2 support at all');
    }
    is3DSupported = false;
  } else {
    is3DSupported = true;
    gl.getExtension('WEBGL_lose_context')?.loseContext();
  }
  return is3DSupported;
};

export const getVolumeManager = () => {
  if (isWebGL2() && !viewManager3d) {
    try {
      const { ViewManager3D } = webvolumeview;
      const manager = new ViewManager3D();

      manager.updateCrossRefOtherViewers = (origViewer) => {
        if (!origViewer?.div || origViewer.actualTool !== 'crossRef') return;

        manager.all_views.forEach((view) => {
          if (
            view.div?.id === origViewer.div.id
            || typeof view.updateCrossRefPoint !== 'function'
          ) return;

          view.updateCrossRefPoint(origViewer);
        });
      };

      manager.initPrograms();
      manager.startAppLoop();
      viewManager3d = manager;
    } catch (error) {
      console.warn('WebGL2 is available, but 3D rendering could not be initialized', error);
      is3DSupported = false;
    }
  }

  return viewManager3d;
};

export const is3DRenderingAvailable = () => getVolumeManager() !== undefined;


export const to3DLibraryToolName = (toolName) => {
  switch (toolName) {
    case toolNames.WWWC:
      return 'windowLevel';
    case toolNames.ZOOM:
      return 'zoom';
    case toolNames.PAN:
      return 'pan';
    case toolNames.ROTATE:
      return 'rotation';
    // case 'rejilla':
    //   return 'rejilla';
    case toolNames.CLIPPING:
      return 'clipping';
    default:
      console.error('tool not found on 3d tools');
  }
};


export const { getHeaderTags, getPixelDataArray } = webvolumeview;

